<template>
  <a-tabs defaultActiveKey="1">
    <a-tab-pane tab="RESPUESTA DEL FORMULARIO" key="1">
      <a-row>
        <a-card>
          <a-card-meta :title="formResp[0].person_name || 'ANÓNIMO'"
                       :description="formResp[0].id_person">
            <a-avatar
              slot="avatar"
              :src="profileSrc"
            />
          </a-card-meta>
        </a-card>
      </a-row>
      <br>
      <a-row v-for="item in formResp">
        <a-collapse accordion>
          <a-collapse-panel :header="item.name">
            <a-descriptions bordered size="small"
                            layout="vertical">
              <a-descriptions-item :label="$t('Pregunta')">{{item.label}}</a-descriptions-item>
              <a-descriptions-item :label="$t('Respuesta')">{{item.value}}</a-descriptions-item>
            </a-descriptions>
          </a-collapse-panel>
        </a-collapse>
      </a-row>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        formResp: [],
        defaultPicture: require('./../../assets/anon_profile.png'),
        profileSrc: require('./../../assets/anon_profile.png')
      }
    },
    mounted () {
      this.fillOutId = this.$route.query.fillOutId
      if (JsUtils.isEmpty(this.fillOutId)) {
        this.$router.push('404')
      } else {
        this.httpClient = new HttpUtil()
        this.consultarRespForm()
      }
    },
    methods: {
      consultarRespForm () {
        this.profileSrc = this.defaultPicture
        this.httpClient.getInstance().get('consultar_form_fillout/' + this.fillOutId)
          .then(response => {
            this.formResp = {...response.data}
            this.loadEmployPicture(this.formResp[0].id_person)
          })
          .catch((error) => {
            Mensajes.error('Error', error.response.data.message)
          })
      },
      loadEmployPicture (idPerson) {
        this.profileSrc = this.defaultPicture
        this.httpClient.getInstance().get('picture_service/render/profile/' + idPerson, {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.profileSrc = window.URL.createObjectURL(blob)
          })
          .catch(() => {})
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Formularios/ConsultarFormFillOut.vue